import React, { ReactNode } from "react";
import { VoiceModel } from "@/actions/db/get-models";
import styles from "@/components/common/voice-selector/selectors/styles/voice-selector-base.module.scss";
import Loader from "@/components/common/loader";
import VirtualizedVoicesGrid from "@/components/pages/home/components/virtualized-grid/virtualized-voices-grid";

export interface VoiceSelectorProps {
  children?: ReactNode;
  isLoading: boolean;
  filteredVoiceList: VoiceModel[];
  handleVoiceModelClick: (model: VoiceModel) => void;
  scrollUpdate: (scrollTop: number | undefined) => void;
  hasSearched?: boolean;
  searchValue?: string;
  needsEmptySpace?: boolean;
}

const VoiceSelectorBase = ({
  children,
  isLoading,
  filteredVoiceList,
  handleVoiceModelClick,
  scrollUpdate,
  hasSearched,
  searchValue,
  needsEmptySpace = true,
}: VoiceSelectorProps) => {
  return (
    <>
      {children}
      {isLoading ? (
        <div className={styles.loader_wrapper}>
          <Loader />
        </div>
      ) : filteredVoiceList.length > 0 ? (
        <VirtualizedVoicesGrid
          voiceList={filteredVoiceList}
          handleVoiceModelClick={handleVoiceModelClick}
          onScroll={scrollUpdate}
          needsEmptySpace={needsEmptySpace}
        />
      ) : (
        <div className={styles.not_found_title}>
          {hasSearched ? (
            <>
              The search for &quot;{searchValue}&quot; didn’t return any results
            </>
          ) : (
            <>It seems you don&apos;t have voices yet!</>
          )}
        </div>
      )}
    </>
  );
};

export default VoiceSelectorBase;
